import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MobileCryptoBinaryTrade from "./MobileHotBinaryTrade/MobileCryptoBinaryTrade/MobileCryptoBinaryTrade";
import MobileForexBinaryTrade from "./MobileHotBinaryTrade/MobileForexBinaryTrade/MobileForexBinaryTrade";
import MobileMetalBinaryTrade from "./MobileHotBinaryTrade/MobileMetalBinaryTrade/MobileMetalBinaryTrade";
import MobileStockBinaryTrade from "./MobileHotBinaryTrade/MobileStockBinaryTrade/MobileStockBinaryTrade";

const PopularMarketTrade = () => {
  const { id } = useParams();

  const [data, setData] = useState([]);

  useEffect(() => {
    if (id) {
      fetch(`https://api.wlfmobile.com/api/user/trade/market/hot/view/${id}`, {
        method: "GET",
      })
        .then((res) => res.json())
        .then((data) => {
          setData(data?.data);
        });
    }
  }, [id]);
  
  return <>
  {data?.market === "Crypto" && <MobileCryptoBinaryTrade />}
  {data?.market === "Forex" && <MobileForexBinaryTrade />}
  {data?.market === "Metal" && <MobileMetalBinaryTrade />}
  {data?.market === "Stock" && <MobileStockBinaryTrade />}
  </>;
};

export default PopularMarketTrade;
